/**
 * Route definition for /chains/coston
 *
 * Renders the shared ChainPage with the `coston` article. Chain facts live in
 * `@/data/chains`; presentation and SEO live in `@/components/ChainPage`.
 *
 * @module routes/chains/coston
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import ChainPage from '@/components/ChainPage'

export const Route = createFileRoute('/$locale/chains/coston')({
  component: function CostonChainPage() {
    return <ChainPage slug="coston" />
  },
})
